import { Injectable } from '@angular/core';
import { SocketService } from '@services/webFeeder/socket.service';
import { ConfigService } from '@services/webFeeder/config.service';
import { MessageWebFeeder } from '@model/webFeeder/message-web-feeder.model';
import { MessageParameterQuote } from '@model/webFeeder/message-parameter-quote.model';
import { environment } from 'src/environments/environment';
import { Subject, Observable , of, map } from 'rxjs';

export class MessageBusinessBookValues {
  public symbol: string;
  public count: number;
  public quoteTrade: any;
}

@Injectable({
  providedIn: 'root'
})
export class BusinessBookService {
  private _message: MessageBusinessBookValues[] = [];
  private serviceSubject = new Subject<MessageEvent>();
  messagesBusinessBook: Observable<any>;

  constructor(
    private configService: ConfigService,
    private socketService: SocketService
  ) { }

  public createSubject() {
    const newService = {
      name: 'BusinessBookType',
      serviceSubject: this.serviceSubject
    };
    this.socketService.register(newService);
    this.messagesBusinessBook = newService.serviceSubject.pipe(map(data => {
      data['parameter'] = data['parameter'].toLowerCase();
      let item = this._message.find(x => x.symbol === data['parameter']);
      if (item) {
        if (data['quoteTrade'] !== undefined) {
          item.quoteTrade = data['quoteTrade'];
        }
      } else {
        item = { symbol: data['parameter'], count: 1, quoteTrade: data['quoteTrade'] }
        this._message.push(item);
        this.configService.writeLog('SOCKET BUSINESSBOOK > Array: (ELSE)');
      }
      return {
        symbol: data['parameter'],
        type: data['type'],
        quoteTrade: item.quoteTrade
      };
    }));
  }

  public reconnectSubscribe() {
    this._message.forEach(element => {
      this.configService.writeLog('RECONNECT BUSINESSBOOK > [' + element.symbol + '] <<<<<');
      if (element.count > 0) {
        this.sendMessageBook('1', element.symbol);
      }
    });
  }

  public subscribeBook(symbol: string, componentName?: string) {
    if (symbol !== ''
      && symbol !== undefined) {
      symbol = symbol.trim().replace(' ', '').toLowerCase();
      const item = this._message.find(x => x.symbol === symbol);
      let total = 0;
      if (!item) {
        total = 1;
        this._message.push({
          symbol: symbol,
          count: total,
          quoteTrade: null
        });
      } else {
        item.count += 1;
        total = item.count;
      }
      this.configService.writeLog('<<<< SUBSCRIBE BUSINESS BOOK [' + total + '][' + symbol.toUpperCase()
        + '][' + (componentName ? componentName.toUpperCase() : null) + '] >>>>');
      this.sendMessageBook('1', symbol, null);
    }
  }

  public unsubscribeBook(symbol: string, componentName?: string) {
    if (symbol !== ''
      && symbol !== undefined) {
      const item = this._message.find(x => x.symbol === symbol);
      if (item) {
        item.count -= 1;
        if (item.count <= 0) {
          this.sendMessageBook('0', symbol);
          item.count = 0;
        }
        this.configService.writeLog('<<<< UNSUBSCRIBE BUSINESS BOOK [' + item.count + '][' + symbol.toUpperCase()
          + '][' + (componentName ? componentName.toUpperCase() : null) + '] >>>>');
      }
    }
  }

  private sendMessageBook(type: string, symbol: string, numberRows?: string) {
    const dataMsg: MessageWebFeeder = new MessageWebFeeder();
    dataMsg.token = this.configService.getToken();
    dataMsg.module = 'quotes';
    dataMsg.service = 'quoteTrade';
    dataMsg.parameterGet = symbol.toLowerCase();
    if (numberRows === null || numberRows === undefined) {
      numberRows = '30';
    }
    const messageParameter = new MessageParameterQuote();
    messageParameter.subsbribetype = type;
    messageParameter.quantidade = numberRows;
    messageParameter.delay = environment.delay_book_business;
    dataMsg.parameters = messageParameter;
    setTimeout(() => {
      this.socketService.signService(dataMsg);
    }, 1000);
  }

}
